import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VImg,{staticClass:"flex-grow-0",attrs:{"src":_vm.imageSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }